function isExternalLink(link) {
  return /https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i.test(link) || link.indexOf('mailto') >= 0;
}

export default isExternalLink;
